<div class="ccl-textarea-wrapper">
  <textarea
    [id]="id"
    class="ccl-textarea"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [rows]="rows"
    [cols]="cols"
    [attr.maxlength]="maxLength"
    [attr.minlength]="minLength"
    [attr.aria-invalid]="error"
    [attr.aria-describedby]="helperText ? id + '-help' : null"
    [style.resize]="resize"
    (input)="onInput($event)"
  >{{ value }}</textarea>

  @if (helperText) {
    <span [id]="id + '-help'" class="ccl-textarea__helper">
      {{ helperText }}
    </span>
  }

  @if (error) {
    <span class="ccl-textarea__error">
      {{ errorMessage }}
    </span>
  }
</div>
